import { useState } from "react";
import { LinkBlock } from "../../LinkBlock/LinkBlock";
import { ByMail } from "./ByMail";
import { InPerson } from "./InPerson";
import styles from "./payment-methods.module.scss";

export const Other = ({
  commonData,
  productName,
  availableMethods,
  product,
}) => {
  const [currentItem, setCurrentItem] = useState(null);

  const toggleActive = (item) => {
    if (item === currentItem) {
      setCurrentItem(null);
    } else {
      setCurrentItem(item);
    }
  };

  return (
    <div className={styles.otherTab}>
      {availableMethods.includes("by_mail") && (
        <>
          <LinkBlock
            className={styles.linkBlock}
            chevronDirection={currentItem === "byMail" ? "up" : "down"}
            onClick={() => {
              toggleActive("byMail");
            }}
          >
            By Mail
          </LinkBlock>
          {currentItem === "byMail" && (
            <ByMail
              paymentInfo={product.payment_methods.by_mail}
              commonData={commonData}
              productName={productName}
            />
          )}
        </>
      )}
      {availableMethods.includes("in_person") && (
        <>
          <LinkBlock
            className={styles.linkBlock}
            chevronDirection={currentItem === "inPerson" ? "up" : "down"}
            onClick={() => {
              toggleActive("inPerson");
            }}
          >
            In Person
          </LinkBlock>
          {currentItem === "inPerson" && (
            <InPerson paymentInfo={product.payment_methods.in_person} />
          )}
        </>
      )}
    </div>
  );
};
